import React from 'react';
import FooterNav from './FooterNav/FooterNav';
import TermesAndConditions from './FooterNav/TermsAndConditions/TermesAndConditions';

const Footer = () => {
    return (
            <div>
                <FooterNav />
                <TermesAndConditions/>
            </div>
    );
};

export default Footer;